module.exports = __webpack_public_path__ + "static/media/iconFlip.7eadbf6e.svg";